import React, { Component } from 'react';
import { compose, graphql } from 'react-apollo';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { withAppContext } from '../contexts/app';
import { sendContactMessageMutation } from 'apps/ask/mutations/send-contact-message';

import Button from 'shared/Button';
import Modal from 'shared/Modal';

class ContactUsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      note: '',
      error: '',
      messageSent: false,
      isValid: false,
      isSending: false
    };
  }

  handleChange = (input, event) => {
    this.setState({ [input]: event.target.value }, this.validateForm);
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const { isValid, isSending, note } = this.state;
    const { sendContactMessageMutation } = this.props;
    const standardError = 'There was an error while sending your message. Please try again later';

    if (!isValid || isSending) return;

    try {
      this.setState({ isSending: true });

      const recaptchaToken = await this.getCaptchaToken();
      const response = await sendContactMessageMutation({
        variables: {
          input: {
            note,
            recaptchaToken
          }
        }
      });

      if (get(response, 'data.sendContactMessage.success')) {
        this.setState({ messageSent: true });
      } else {
        const notice = get(response, 'data.sendContactMessage.notice');
        this.setState({ error: notice || standardError });
      }
    } catch (error) {
      this.setState({ error: standardError });
    } finally {
      this.setState({ isSending: false });
    }
  }

  async getCaptchaToken() {
    const { app } = this.props;

    return grecaptcha
      .execute(app.recaptchaSiteKey, { action: 'contact' });
  }

  validateForm = () => {
    this.setState({ isValid: this.isFormValid() });
  }

  isFormValid() {
    const { note } = this.state;

    if (!note) return false;

    return true;
  }

  renderForm() {
    const { isSending, error } = this.state;

    return (
      <form className="contact-us-form" onSubmit={this.handleSubmit} noValidate>
        <h3>We would love to hear from you!</h3>
        <p>Fill in your message below and we will be in touch.</p>

        {error && (<p className="error">{error}</p>)}

        <div className="form-group">
          <label htmlFor="note">
            Add your message
          </label>
          <textarea
            id="note"
            className="textarea"
            onChange={(v) => this.handleChange('note', v)}
            onBlur={this.validateForm}
            value={this.state.note}
          />
        </div>

        <Button
          type="submit"
          className="button button--large button--gradient"
          disabled={!this.state.isValid}
          showSpinner={isSending}
        >
          {isSending ? 'Sending...' : 'Send'}
        </Button>
      </form>
    );
  }

  renderThankYouMessage() {
    return (
      <div className="thank-you-message">
        <h3>Thank you for your message!</h3>
        <p>
          You will hear from us soon.
        </p>

        <Button className="button button--large button--gradient" onClick={this.props.onModalClose}>
          Close
        </Button>
      </div>
    );
  }

  render() {
    const { messageSent } = this.state;

    return (
      <Modal className="contact-us-modal" headerText="Contact Us" onModalClose={this.props.onModalClose}>
        {messageSent ? this.renderThankYouMessage() : this.renderForm()}
      </Modal>
    );
  }
}

ContactUsModal.propTypes = {
  app: PropTypes.object.isRequired,
  onModalClose: PropTypes.func.isRequired,
  sendContactMessageMutation: PropTypes.func.isRequired
};

export default compose(
  graphql(sendContactMessageMutation, {
    name : 'sendContactMessageMutation'
  }),
  withAppContext
)(ContactUsModal);
